import { render, staticRenderFns } from "./SignupCarousel.vue?vue&type=template&id=9aed6458&scoped=true"
import script from "./SignupCarousel.js?vue&type=script&lang=js&external"
export * from "./SignupCarousel.js?vue&type=script&lang=js&external"
import style0 from "./SignupCarousel.scss?vue&type=style&index=0&id=9aed6458&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aed6458",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotImage: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Atoms/Image/Image.vue').default})
